const base = {
  male: [
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-stage1.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-stage2.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-stage3.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-stage4.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-stage5.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-stage6.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-stage7.png')
  ],
  female: [
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-f-stage1.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-f-stage2.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-f-stage3.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-f-stage4.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-f-stage5.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-f-stage6.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/conny-f-stage7.png')
  ]
}
const animated = {
  male: [
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-stage1-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-stage2-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-stage3-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-stage4-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-stage5-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-stage6-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-stage7-blink.png')
  ],
  female: [
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-f-stage1-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-f-stage2-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-f-stage3-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-f-stage4-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-f-stage5-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-f-stage6-blink.png'),
    require('../../../docs/connextcc-conny/assets-v1/pet/anim/conny-f-stage7-blink.png')
  ]
}

const hungry = {
  male: [1, 2, 3, 4, 5, 6, 7].map(stage => require(`../../../docs/connextcc-conny/assets-v1/pet/conny-stage${stage}-hungry.png`)),
  female: [1, 2, 3, 4, 5, 6, 7].map(stage => require(`../../../docs/connextcc-conny/assets-v1/pet/conny-f-stage${stage}-hungry.png`))
}

const sulking = {
  male: [1, 2, 3, 4, 5, 6, 7].map(stage => require(`../../../docs/connextcc-conny/assets-v1/pet/conny-stage${stage}-sulking.png`)),
  female: [1, 2, 3, 4, 5, 6, 7].map(stage => require(`../../../docs/connextcc-conny/assets-v1/pet/conny-f-stage${stage}-sulking.png`))
}

export const connyMenuAssets = {
  pet: base.male[0],
  checkin: require('../../../docs/connextcc-conny/assets-v1/menu/checkin-1.png'),
  mission: require('../../../docs/connextcc-conny/assets-v1/menu/mission-1.png')
}

export function connyStageImage (stage, gender) {
  const safeGender = gender === 'female' ? 'female' : 'male'
  const safeStage = Math.max(1, Math.min(7, Number(stage) || 1)) - 1
  return base[safeGender][safeStage]
}

export function connyPetImage (pet, allowAnimation = true) {
  const gender = pet && pet.gender === 'female' ? 'female' : 'male'
  const stage = Math.max(1, Math.min(7, Number(pet && pet.stage ? pet.stage : 1))) - 1
  if (pet && pet.mood === 'sulking') return sulking[gender][stage]
  if (pet && pet.mood === 'hungry') return hungry[gender][stage]
  return allowAnimation ? animated[gender][stage] : base[gender][stage]
}
